import { Locale } from 'modules/i18n';

export const supportedNetworksTranslation = {
  [Locale.en]: {
    mainnets: 'Mainnets',
    testnets: 'Testnets',
    signets: 'Signets',
  },
};
